import React, { useState } from 'react';
import * as S from './styles';

const Tooltip = ({ children, text, disable, color, bottom, left, width }: any) => {
  const [hide, setHide] = useState(true);

  return (
    <S.TooltipArea
      onMouseOver={() => setHide(false)}
      onMouseOut={() => setHide(true)}
    >
      {children}

        {disable && !hide && <S.Tooltip color={color} bottom={bottom} left={left} width={width}>{text}</S.Tooltip>}
    </S.TooltipArea>
  );
};

export default Tooltip;
